import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { setContactInformation } from "./formSlice";
import { setShowServerErrorMessage } from "./errorManagementSlice";
import errorStatusProvider from "../utils/errorStatusProvider";

const initialState = {
  page_content: null,
  loading: true,
  error: null,
};

const baseUrl = process.env.REACT_APP_API;

export const fetchContactInformation = createAsyncThunk(
  "contactInformationScreen/fetchContactInformation",
  async (country) => {
    return fetch(
      `${baseUrl}/api/registration-form-page/3/${country.countryCode}/`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Accept-Language":
            country.language === "en" ? "en-UK" : country.language,
        },
      }
    ).then((res) => errorStatusProvider(res));
  }
);

export const getContactInformation =
  (countryCode, language) => async (dispatch) => {
    const result = await dispatch(
      fetchContactInformation({ countryCode, language })
    );
    const { data, responseStatus } = result.payload;
    dispatch(setShowServerErrorMessage(responseStatus));
    dispatch(setContactInformation(data?.page_content));

    return data;
  };

export const contactInformationSlice = createSlice({
  name: "contactInformationScreen",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchContactInformation.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchContactInformation.fulfilled, (state, action) => {
        state.loading = false;
        state.page_content = action.payload.data.page_content;
      })
      .addCase(fetchContactInformation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
      });
  },
});

export default contactInformationSlice.reducer;
